import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'


const StyledHeader = styled.header`
  .backBtn {
    width: 90%;
    margin: 1rem auto;
    display: flex;
    align-items: center;
    small {
      font-size: 14px;
      margin-left: 8px;
    }
  }
`

export default function MobileHeader({ isLobby=false }) {
  const history = useHistory()

  const goBack = () => {
    history.goBack()
  }
  
  return (
    <StyledHeader>
      {/* <img src={fixedAssets.bannerM} width="100%" className="mx-auto d-block m-0" alt="event visual" /> */}
      {!isLobby &&
        <div className='btn c-button px-4 py-1 ml-4 mt-2' onClick={goBack}>
          <small>Back</small>
        </div>
      }
    </StyledHeader>
  )
}
